export default __webpack_public_path__ + "media/images/logos/logo_light-02cf95a74ae419e8b01e9c11ada90894.png";